import { cloudChiprApi } from "../../../services/cloudchipr.api";
import { askAiThunkFixedCacheKey } from "../thunks/askAiThunk";

export const postAskAiSelector =
  cloudChiprApi.endpoints.postUsersMeAskAiQuestions.select(
    askAiThunkFixedCacheKey,
  );
